// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tts-controls {
  position: fixed;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.88);
  border-radius: 12px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  cursor: move;
  -webkit-user-select: none;
          user-select: none;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  max-width: calc(100vw - 20px);
  box-sizing: border-box;
}

.tts-controls.tts-minimized {
  padding: 8px 14px;
  cursor: pointer;
  gap: 6px;
  font-size: 13px;
  color: #fff;
  flex-shrink: 0;
}

.tts-btn {
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  transition: background 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tts-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}

.tts-btn:disabled {
  opacity: 0.4;
  cursor: default;
}

.tts-btn:disabled:hover {
  background: transparent;
}

.tts-btn.active {
  background: rgba(79, 172, 254, 0.3);
  color: #4facfe;
}

.tts-btn-read {
  color: #4facfe;
}

.tts-btn-read:hover {
  background: rgba(79, 172, 254, 0.2);
}

.tts-btn-auto {
  color: #4caf50;
}

.tts-progress {
  flex: 1 1;
  min-width: 40px;
  max-width: 100px;
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  overflow: hidden;
}

.tts-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #4facfe, #00f2fe);
  transition: width 0.3s ease;
}

.tts-speed,
.tts-voice {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #fff;
  font-size: 12px;
  flex-shrink: 0;
}

.tts-speed select,
.tts-voice select {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  padding: 3px 6px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  max-width: 100px;
}

.tts-speed select option,
.tts-voice select option {
  background: #333;
  color: #fff;
}

.tts-status-text {
  color: rgba(255, 255, 255, 0.6);
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
  flex-shrink: 0;
}

.tts-close {
  margin-left: 4px;
}

.tts-drag-handle {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.5);
  cursor: grab;
  flex-shrink: 0;
}

.tts-drag-handle:active {
  cursor: grabbing;
}

@media (max-width: 768px) {
  .tts-controls {
    left: 10px !important;
    right: 10px;
    top: auto !important;
    bottom: 10px !important;
    transform: none !important;
    width: auto;
    flex-wrap: nowrap;
    justify-content: center;
    padding: 8px 12px;
    gap: 6px;
  }

  .tts-controls.tts-minimized {
    width: auto;
    left: 50% !important;
    transform: translateX(-50%) !important;
    right: auto;
  }

  .tts-progress {
    min-width: 30px;
    max-width: 60px;
  }

  .tts-status-text {
    max-width: 60px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/tts/TTSControls.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yCAAyC;EACzC,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,2BAA2B;EAC3B,mCAAmC;EACnC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;IACrB,WAAW;IACX,oBAAoB;IACpB,uBAAuB;IACvB,0BAA0B;IAC1B,WAAW;IACX,iBAAiB;IACjB,uBAAuB;IACvB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,sCAAsC;IACtC,WAAW;EACb;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".tts-controls {\n  position: fixed;\n  z-index: 9999;\n  background: rgba(0, 0, 0, 0.88);\n  border-radius: 12px;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);\n  cursor: move;\n  user-select: none;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  max-width: calc(100vw - 20px);\n  box-sizing: border-box;\n}\n\n.tts-controls.tts-minimized {\n  padding: 8px 14px;\n  cursor: pointer;\n  gap: 6px;\n  font-size: 13px;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.tts-btn {\n  background: transparent;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 8px;\n  transition: background 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.tts-btn:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.tts-btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.tts-btn:disabled:hover {\n  background: transparent;\n}\n\n.tts-btn.active {\n  background: rgba(79, 172, 254, 0.3);\n  color: #4facfe;\n}\n\n.tts-btn-read {\n  color: #4facfe;\n}\n\n.tts-btn-read:hover {\n  background: rgba(79, 172, 254, 0.2);\n}\n\n.tts-btn-auto {\n  color: #4caf50;\n}\n\n.tts-progress {\n  flex: 1;\n  min-width: 40px;\n  max-width: 100px;\n  height: 4px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.tts-progress-bar {\n  height: 100%;\n  background: linear-gradient(90deg, #4facfe, #00f2fe);\n  transition: width 0.3s ease;\n}\n\n.tts-speed,\n.tts-voice {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #fff;\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.tts-speed select,\n.tts-voice select {\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  padding: 3px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  max-width: 100px;\n}\n\n.tts-speed select option,\n.tts-voice select option {\n  background: #333;\n  color: #fff;\n}\n\n.tts-status-text {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 11px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 80px;\n  flex-shrink: 0;\n}\n\n.tts-close {\n  margin-left: 4px;\n}\n\n.tts-drag-handle {\n  width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: rgba(255, 255, 255, 0.5);\n  cursor: grab;\n  flex-shrink: 0;\n}\n\n.tts-drag-handle:active {\n  cursor: grabbing;\n}\n\n@media (max-width: 768px) {\n  .tts-controls {\n    left: 10px !important;\n    right: 10px;\n    top: auto !important;\n    bottom: 10px !important;\n    transform: none !important;\n    width: auto;\n    flex-wrap: nowrap;\n    justify-content: center;\n    padding: 8px 12px;\n    gap: 6px;\n  }\n\n  .tts-controls.tts-minimized {\n    width: auto;\n    left: 50% !important;\n    transform: translateX(-50%) !important;\n    right: auto;\n  }\n\n  .tts-progress {\n    min-width: 30px;\n    max-width: 60px;\n  }\n\n  .tts-status-text {\n    max-width: 60px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
